// Every conversation runs a fixed 20 minutes from startAt (see roomsService).
export const ROOM_DURATION_MS = 20 * 60 * 1000;

export type ScheduledRoom = {
  id: string;
  name: string;
  startAt: Date;
  endAt: Date;
};

/**
 * The first room in `rooms` whose time overlaps a conversation starting at
 * `startAt`, or null. One person can't attend two conversations at once (#141),
 * so creating/rescheduling into an overlapping slot must be refused.
 * Back-to-back (one ends exactly when the other starts) is fine.
 */
export function findConflictingRoom<T extends ScheduledRoom>(
  rooms: T[],
  startAt: Date,
  excludeRoomId?: string,
): T | null {
  const start = startAt.getTime();
  const end = start + ROOM_DURATION_MS;

  return (
    rooms.find(
      (room) =>
        room.id !== excludeRoomId &&
        room.startAt.getTime() < end &&
        start < room.endAt.getTime(),
    ) ?? null
  );
}
